/**
 * Gestionnaire unifié des modales
 * Centralise la gestion d'ouverture/fermeture des modales avec support Escape
 */

/**
 * Fonction globale pour fermer les modales
 * @param {string} modalId - L'ID de la modal à fermer
 */
export function closeModal(modalId) {
  const modal = document.getElementById(modalId);
  if (modal) {
    // Méthodes multiples de fermeture pour compatibilité
    modal.style.display = 'none';
    modal.classList.remove('show'); // Pour HelpModal

    // Nettoyer les handlers spécifiques s'ils existent
    if (modal._escapeHandler) {
      document.removeEventListener('keydown', modal._escapeHandler);
      delete modal._escapeHandler;
    }

    console.log(`✅ Modal ${modalId} fermé`);
  } else {
    console.error(`❌ Modal ${modalId} introuvable`);
  }
}

/**
 * Fonction pour ouvrir un modal avec support Escape
 * @param {string} modalId - L'ID de la modal à ouvrir
 */
export function openModalWithEscape(modalId) {
  const modal = document.getElementById(modalId);
  if (modal) {
    modal.style.display = 'block';

    // Créer un handler spécifique pour ce modal
    const escapeHandler = function(e) {
      if (e.key === 'Escape') {
        closeModal(modalId);
      }
    };

    // Stocker la référence pour pouvoir la supprimer plus tard
    modal._escapeHandler = escapeHandler;
    document.addEventListener('keydown', escapeHandler);

    console.log(`✅ Modal ${modalId} ouvert avec support Escape`);
  }
}

/**
 * Gestionnaire global des touches Escape pour toutes les modales
 * Gère automatiquement la fermeture des modales visibles
 */
export function initGlobalEscapeHandler() {
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      console.log('Escape pressé !');

      // Liste des modales à vérifier avec détection améliorée
      const modalIds = [
        'data-import-modal',
        'data-modal',
        'period-modal',
        'colors-modal',
        'help-modal',
        'prefs-modal',
        'create-event-modal',
        'notes-modal'
      ];

      modalIds.forEach(modalId => {
        const modal = document.getElementById(modalId);
        if (modal) {
          const computedStyle = window.getComputedStyle(modal);
          const isVisible = modal.style.display === 'block' ||
                           modal.style.display === 'flex' ||
                           modal.classList.contains('show') ||
                           (computedStyle.display !== 'none' && computedStyle.visibility !== 'hidden');

          if (isVisible) {
            console.log(`Fermeture de ${modalId} avec Escape`);
            closeModal(modalId);
          }
        }
      });
    }
  });
}

/**
 * Expose les fonctions globalement pour compatibilité
 */
export function exposeGlobalModalFunctions() {
  if (typeof window !== 'undefined') {
    window.closeModal = closeModal;
    window.openModalWithEscape = openModalWithEscape;
  }
}